import { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/homeEventServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import {validateFile } from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';


const Homeevent = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});  
  const [formData, setFormData] = useState({
    id: null,
    logo: null,
    event_date: '',
    event_location: '',
    hotel_name: '',
    event_name: '',
    theme_name: '',
    shortname: '',
    conf_work_starts: '',
    event_date_on: '',
    alt_img_name: '',
    event_title: ''
  });

  // Fetch data from API
  const fetchData = useCallback(async () => {
    setLoading(true);
    try{
    const response = await getData();
    if (response.data.length > 0) {
      setFormData(response.data[0]); // Load first record into the form
    }
  }
  catch(error){
    console.error('Failed to fetching data:', error);
  }
  finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const validateForm = () => {
  const newErrors = {};
  if (!formData.uploadedfile && formData.logo === null) {
    if (!errors.uploadedfile) newErrors.uploadedfile = "Conference Logo is required";
  }
  if (!formData.event_title) newErrors.event_title = "Conference title is required";
  if (!formData.event_name) newErrors.event_name = "Conference name is required";
  if (!formData.event_date) newErrors.event_date = "Conference date is required";
  if (!formData.event_location) newErrors.event_location = "Conference location is required";
  if (!formData.hotel_name) newErrors.hotel_name = "Hotel name is required";
  if (!formData.theme_name) newErrors.theme_name = "Conference theme is required";
  if (!formData.conf_work_starts) newErrors.conf_work_starts = "Work start date is required";
  if (!formData.event_date_on) newErrors.event_date_on = "Countdown timer date is required";
  if (!formData.alt_img_name) newErrors.alt_img_name = "Alt image name is required";
  if (!formData.shortname) newErrors.conf_shortname = "Shortname is required";
  if (formData.shortname && !/^[A-Z][a-zA-Z]*(?: [A-Za-z0-9]+)*$/.test(formData.shortname)) {
  newErrors.shortname =
    'Shortname must start with a capital letter and can include letters, numbers, and spaces (e.g., Surgery 2025)';
  }

  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
};

  // Handle input changes
  const handleChange = async (e) => {
    try{
      const { name, value, files } = e.target;
      const file = files?.[0]
      // Create a copy of the current form data
      let updatedData = { ...formData };
      let updatedErrors = { ...errors };
      if (file) {
          const fileType = file.type.includes("image") ? "img" : "pdf";
          const isValid = await validateFile(file, setErrors,name,fileType);
          if (isValid) {
            updatedData[name] = file;
            updatedErrors[name] = '';
          }
          else{
            return ; // Don't update if invalid
          }
        }
      else{
          updatedData[name] = value;
          if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
          }
        }
        setFormData(updatedData);
        setErrors(updatedErrors);
    }
    catch (error) {
      console.error("Error in handleChange:", error);
    }
  
};

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    try{
    const form = new FormData();
    form.append('id', formData.id);
    form.append('event_date', formData.event_date);
    form.append('event_location', formData.event_location);
    form.append('hotel_name', formData.hotel_name);
    form.append('event_name', formData.event_name);
    form.append('theme_name', formData.theme_name);
    form.append('shortname', formData.shortname);
    form.append('conf_work_starts', formData.conf_work_starts);
    form.append('event_date_on', formData.event_date_on);
    form.append('alt_img_name', formData.alt_img_name);
    form.append('event_title', formData.event_title);
    form.append('uploadedfile', formData.uploadedfile);
    

    const result = await updateData(form);
    if (result.status === 200) {
      fetchData(); // Refresh data after update
      toast.success("Saved Successfully!", {position: 'top-right'});
    } else {
      toast.error(result.message ||"Failed to update data. Please try again.", {position: 'top-right'});
    }
  }
  catch (error) {
        console.error("Error during form submission:", error);
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
      <div>
        <div className="container-fluid p-4">
           <div className="row">
            <div className="col-8">
            <p className="fs-4">Event Pages / Conference <b>/ Conference Details</b></p>
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>Add</button> */}
              </div>
            </div>

          {/* Editable Form (Always Visible) */}
          <div className="card p-4">
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Conference Title <small className='text-danger'> * </small><small className='form-label-note'>(Series: 3rd International Conference on)</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="event_title"
                    value={formData.event_title}
                    onChange={handleChange}
                    isInvalid={!!errors.event_title}
                  />
                  <Form.Control.Feedback type="invalid">{errors.event_title}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Conference Name <small className='text-danger'> * </small><small className='form-label-note'>(Subject: Neuroscience and Psychology)</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="event_name"
                    value={formData.event_name}
                    onChange={handleChange}
                    isInvalid={!!errors.event_name}
                  />
                <Form.Control.Feedback type="invalid">{errors.event_name}</Form.Control.Feedback>

                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Conference Date <small className='text-danger'> * </small><small className='form-label-note'>(Eg:November 08-09,2025)</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="event_date"
                    value={formData.event_date}
                    onChange={handleChange}
                    isInvalid={!!errors.event_date}
                  />
                <Form.Control.Feedback type="invalid">{errors.event_date}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Conference Location <small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="text"
                    name="event_location"
                    value={formData.event_location}
                    onChange={handleChange}
                    isInvalid={!!errors.event_location}
                  />
                  <Form.Control.Feedback type="invalid">{errors.event_location}</Form.Control.Feedback>

                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label className='form-label-custom'>Hotel Name <small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="text"
                    name="hotel_name"
                    value={formData.hotel_name}
                    onChange={handleChange}
                    isInvalid={!!errors.hotel_name}
                  />
                <Form.Control.Feedback type="invalid">{errors.hotel_name}</Form.Control.Feedback>

                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label className='form-label-custom'>Countdown Timer  <small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="date"
                    name="event_date_on"
                    value={formData.event_date_on}
                    onChange={handleChange}
                    isInvalid={!!errors.event_date_on}
                  />
                  <Form.Control.Feedback type="invalid">{errors.event_date_on}</Form.Control.Feedback>

                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Conference Theme  <small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="text"
                    name="theme_name"
                    value={formData.theme_name}
                    onChange={handleChange}
                    isInvalid={!!errors.theme_name}
                  />
                  <Form.Control.Feedback type="invalid">{errors.theme_name}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Shortname <small className='text-danger'> * </small></Form.Label>
                <Form.Control
                  type="text"
                  name="shortname"
                  value={formData.shortname}
                  onChange={handleChange}
                  isInvalid={!!errors.shortname}
                />
                <Form.Control.Feedback type="invalid">{errors.shortname}</Form.Control.Feedback>
              </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Work started on  <small className='text-danger'> * </small><small className='form-label-note'>(Config month for dashboard analytics)</small></Form.Label>
                  <Form.Control
                    type="date"
                    name="conf_work_starts"
                    value={formData.conf_work_starts}
                    onChange={handleChange}
                    isInvalid={!!errors.conf_work_starts}
                  />
                <Form.Control.Feedback type="invalid">{errors.conf_work_starts}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Conference Logo <small className='text-danger'> * </small><small className='text-primary form-label-note' >(Dimension:250x250 | Size:10kb-60kb)</small></Form.Label>
                  <Form.Control type="file" name="uploadedfile" onChange={handleChange} isInvalid={!!errors.uploadedfile} accept="image/*"/>
                  <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Alt Image Name  <small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="text"
                    name="alt_img_name"
                    value={formData.alt_img_name}
                    onChange={handleChange}
                    isInvalid={!!errors.alt_img_name}
                  />
                  <Form.Control.Feedback type="invalid">{errors.alt_img_name}</Form.Control.Feedback>
                </Form.Group>

                {formData.logo && (
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label style={{marginRight:'5px'}} className='form-label-custom'>Logo Preview</Form.Label>
                  <div style={{width:'200px',height:'200px'}}> 
                  
                    <img height='100%' width='100%' className='rounded' src={formData?.logo} alt={formData?.alt_img_name||"logo preview"} style={{objectFit: 'cover' }}
                    crossOrigin="anonymous" />
                  
                  </div>
                </Form.Group>
                )}
              </div >
              <div  className='row'>
                <div className='col-md-12'>
                  <div>
                  <Button  variant="success" type="submit">Submit</Button>
                  </div>
                </div>
            </div>
            </Form>
          </div>
        </div>
        <Footer />
      </div>
      )}
      </div>
    </div>
  );
};

export default Homeevent;
